import { itemsNotInPlan, planTitle, deliveryText } from './shoppingPlan';

// הדפסה / שמירה כ-PDF של תוכנית הקנייה (ShoppingPlan.jsx): נפתח חלון עם דף נקי - רשימה לכל חנות עם ☐ לסימון בזמן הקנייה -
// וחלון ההדפסה של הדפדפן נפתח מעליו (שם בוחרים "שמירה כ-PDF"). דף נפרד ולא @media print על האתר: בלי כפתורים ותפריטים,
// ומתאים לדף A4. כל טקסט עובר escape (שמות מוצרים מגיעים מאתרי החנויות).

const esc = (value) => String(value ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));
const formatPrice = (n) => `₪${Number(n || 0).toFixed(2)}`;
const qtyText = (x) => (x.isWeighable ? `${x.qty} ק"ג` : `${x.qty}`);

const STYLE = `
  * { box-sizing: border-box; }
  body { margin: 0; padding: 24px; font-family: "Segoe UI", Arial, "Noto Sans Hebrew", sans-serif; color: #111; font-size: 14px; }
  header { display: flex; justify-content: space-between; align-items: baseline; border-bottom: 2px solid #1a3f9c; padding-bottom: 8px; margin-bottom: 14px; }
  h1 { margin: 0; font-size: 22px; color: #1a3f9c; }
  .date { color: #555; font-size: 13px; }
  .summary { font-size: 16px; font-weight: 700; margin: 0 0 16px; }
  .store { break-inside: avoid; margin-bottom: 18px; border: 1px solid #ccc; border-radius: 8px; padding: 10px 12px; }
  .store h2 { display: flex; justify-content: space-between; margin: 0 0 6px; font-size: 17px; }
  table { width: 100%; border-collapse: collapse; }
  td { padding: 5px 4px; border-top: 1px solid #eee; vertical-align: top; }
  td.box { width: 24px; font-size: 16px; }
  td.qty, td.price { white-space: nowrap; width: 1%; padding-inline-start: 12px; }
  .num { direction: ltr; unicode-bidi: isolate; font-variant-numeric: tabular-nums; }
  .total { font-size: 16px; font-weight: 700; text-align: left; margin-top: 4px; }
  .rest { color: #555; }
  .limit { font-size: 11px; color: #7d4e00; }
  .delivery { margin: 6px 0 0; font-size: 13px; color: #333; }
  footer { margin-top: 18px; color: #666; font-size: 11px; line-height: 1.5; }
  @page { size: A4; margin: 14mm; }
  @media print { body { padding: 0; } }
`;

export const printPlan = (plan, items) => {
  const win = window.open('', '_blank');
  if (!win) return false;   // חוסם חלונות קופצים

  const date = new Date().toLocaleString('he-IL', { dateStyle: 'short', timeStyle: 'short' });
  const groups = plan.groups.map((g) => `
    <section class="store">
      <h2><span>${esc(g.store.name)}</span><span class="num">${formatPrice(g.total)}</span></h2>
      <table>
        ${g.items.map(({ item, cost, limited, limit }) => `
          <tr>
            <td class="box">☐</td>
            <td>${esc(item.name)}${limited ? `<div class="limit">מבצע עד ${limit} יח', השאר במחיר רגיל</div>` : ''}</td>
            <td class="qty num">${esc(qtyText(item))}</td>
            <td class="price num">${formatPrice(cost)}</td>
          </tr>`).join('')}
      </table>
      ${g.delivery ? `<p class="delivery">🚚 ${esc(deliveryText(g.delivery))}</p>` : ''}
    </section>`).join('');

  const rest = itemsNotInPlan(plan, items);
  const restHtml = rest.length ? `
    <section class="store rest">
      <h2><span>לא נמכר כרגע באף חנות</span></h2>
      <table>${rest.map((x) => `<tr><td class="box">☐</td><td>${esc(x.name)}</td><td class="qty num">${esc(qtyText(x))}</td><td></td></tr>`).join('')}</table>
    </section>` : '';

  win.document.write(`<!doctype html>
<html lang="he" dir="rtl">
<head><meta charset="utf-8"><title>רשימת קניות - זול בכפר</title><style>${STYLE}</style></head>
<body>
  <header><h1>🛒 רשימת קניות - זול בכפר</h1><span class="date">${esc(date)}</span></header>
  <p class="summary">${esc(planTitle(plan))} - סה"כ <span class="num">${formatPrice(plan.total)}</span></p>
  ${groups}
  ${restHtml}
  <footer>
    המחירים לפי זול בכפר (${esc(window.location.host)}) נכון למועד ההדפסה, ונאספו מאתרי החנויות.
    המחיר המחייב הוא המחיר בחנות בזמן הקנייה.
  </footer>
  <script>window.onload = function () { window.focus(); window.print(); };</script>
</body>
</html>`);
  win.document.close();
  return true;
};
